// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"GuaranteeTag_labelWrapper__ypTbg"};